
import { Link } from 'react-router-dom';

export default function Services() {
  const residentialServices = [
    {
      icon: 'ri-home-4-line',
      title: 'Ménage à Domicile',
      description: 'Nettoyage complet de votre domicile selon vos besoins',
      features: ['Aspirateur et serpillère', 'Dépoussiérage', 'Sanitaires', 'Cuisine', 'Chambres', 'Salon']
    },
    {
      icon: 'ri-window-line',
      title: 'Lavage de Vitres',
      description: 'Vitres éclatantes intérieur et extérieur',
      features: ['Matériel professionnel', 'Sans traces', 'Encadrements', 'Régulier ou ponctuel']
    },
    {
      icon: 'ri-broom-line',
      title: 'Nettoyage Profond',
      description: 'Grand ménage saisonnier et nettoyage intensif',
      features: ['Déménagement', 'Fin de bail', 'Après travaux', 'Saisonnier']
    },
    {
      icon: 'ri-leaf-line',
      title: 'Produits Écologiques',
      description: 'Solutions respectueuses de l\'environnement',
      features: ['Produits bio', 'Non toxiques', 'Biodégradables', 'Sécurisé enfants']
    }
  ];

  const commercialServices = [
    {
      icon: 'ri-building-line',
      title: 'Bureaux & Espaces de Travail',
      description: 'Maintien de la propreté de vos locaux professionnels',
      features: ['Espaces de travail', 'Salles de réunion', 'Accueil', 'Sanitaires', 'Espaces communs', 'Nettoyage quotidien']
    },
    {
      icon: 'ri-store-line',
      title: 'Commerces & Boutiques',
      description: 'Services d\'entretien adaptés aux espaces commerciaux',
      features: ['Vitrines et devantures', 'Espaces clients', 'Zones de stockage', 'Sanitaires publics', 'Sol haute fréquentation', 'Horaires flexibles']
    },
    {
      icon: 'ri-shield-keyhole-line',
      title: 'Désinfection Professionnelle',
      description: 'Traitement sanitaire complet pour votre sécurité',
      features: ['Produits certifiés', 'Surfaces de contact', 'Climatisation', 'Certification', 'Protocoles COVID', 'Documentation fournie']
    },
    {
      icon: 'ri-hospital-line',
      title: 'Secteur Médical',
      description: 'Nettoyage spécialisé pour établissements de santé',
      features: ['Normes sanitaires', 'Stérilisation', 'Déchets médicaux', 'Zones sensibles']
    }
  ];

  const laundryServices = [
    {
      icon: 'ri-shirt-line',
      title: 'Lessive à Domicile',
      description: 'Prise en charge complète de votre linge',
      features: ['Collecte domicile', 'Lavage délicat', 'Séchage optimal', 'Livraison rapide']
    },
    {
      icon: 'ri-iron-line',
      title: 'Repassage Professionnel',
      description: 'Repassage impeccable pour tous vos vêtements',
      features: ['Technique experte', 'Finition parfaite', 'Pliage soigné', 'Emballage protection']
    },
    {
      icon: 'ri-t-shirt-line',
      title: 'Nettoyage à Sec',
      description: 'Traitement spécialisé pour vos vêtements délicats',
      features: ['Tissus délicats', 'Costumes', 'Robes de soirée', 'Cuir et daim']
    },
    {
      icon: 'ri-handbag-line',
      title: 'Accessoires & Maroquinerie',
      description: 'Entretien de vos sacs, chaussures et accessoires',
      features: ['Sacs à main', 'Chaussures cuir', 'Ceintures', 'Restauration']
    }
  ];

  const deliveryServices = [
    {
      icon: 'ri-shopping-cart-line',
      title: 'Courses Personnelles',
      description: 'Vos courses alimentaires faites avec soin',
      features: ['Liste personnalisée', 'Produits frais', 'Marques préférées', 'Livraison rapide']
    },
    {
      icon: 'ri-truck-line',
      title: 'Livraison Express',
      description: 'Service de livraison rapide pour particuliers',
      features: ['Moins de 2h', 'Produits urgents', 'Médicaments', 'Documents']
    },
    {
      icon: 'ri-building-2-line',
      title: 'Livraison Entreprise',
      description: 'Solutions logistiques pour professionnels',
      features: ['Fournitures bureau', 'Produits d\'entretien', 'Livraison programmée', 'Facturation centralisée']
    },
    {
      icon: 'ri-gift-line',
      title: 'Colis & Cadeaux',
      description: 'Livraison de colis et présents avec attention',
      features: ['Emballage soigné', 'Livraison discrète', 'Suivi temps réel', 'Confirmation réception']
    }
  ];

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Nos 4 Services Complets
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Des solutions personnalisées pour tous vos besoins, 
            avec la garantie d'un service de qualité professionnelle
          </p>
        </div>

        {/* Services Résidentiels */}
        <div id="residential" className="mb-20">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              <i className="ri-home-heart-line text-blue-600 mr-3"></i>
              Entretien Résidentiel
            </h3>
            <p className="text-lg text-gray-600">
              Un service personnalisé pour votre confort au quotidien
            </p>
            <Link 
              to="/services/residential"
              className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium mt-2 cursor-pointer"
            >
              En savoir plus
              <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {residentialServices.map((service, index) => (
              <div key={index} className="bg-gray-50/50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div 
                  className="w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-6 bg-cover bg-center"
                  style={{
                    backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20residential%20cleaning%20service%20$%7Bservice.title.toLowerCase%28%29%7D%20with%20modern%20equipment%20in%20bright%20clean%20home%20interior%2C%20high%20quality%20photography%2C%20blue%20and%20white%20color%20scheme%2C%20professional%20cleaning%20supplies%20and%20tools%2C%20sparkling%20clean%20surfaces%2C%20natural%20lighting%2C%20commercial%20grade%20quality&width=400&height=400&seq=residential-${index}&orientation=squarish')`
                  }}
                >
                  <i className={`${service.icon} text-3xl text-white drop-shadow-lg`}></i>
                </div>
                <h4 className="text-xl font-semibold text-gray-900 mb-3 text-center">
                  {service.title}
                </h4>
                <p className="text-gray-600 mb-4 text-center">
                  {service.description}
                </p>
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                <button 
                  onClick={scrollToContact}
                  className="w-full mt-6 bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Demander un devis
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Services Commerciaux */}
        <div id="commercial" className="mb-20">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              <i className="ri-building-2-line text-green-600 mr-3"></i>
              Nettoyage Commercial
            </h3>
            <p className="text-lg text-gray-600">
              Des solutions professionnelles pour maintenir vos locaux impeccables
            </p>
            <Link 
              to="/services/commercial"
              className="inline-flex items-center text-green-600 hover:text-green-800 font-medium mt-2 cursor-pointer"
            >
              En savoir plus
              <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {commercialServices.map((service, index) => (
              <div key={index} className="bg-gray-50/50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div 
                  className="w-20 h-20 bg-gradient-to-br from-green-500 to-green-600 rounded-2xl flex items-center justify-center mx-auto mb-6 bg-cover bg-center"
                  style={{
                    backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20commercial%20cleaning%20service%20$%7Bservice.title.toLowerCase%28%29%7D%20in%20modern%20office%20building%20environment%2C%20high%20quality%20commercial%20photography%2C%20green%20and%20white%20color%20scheme%2C%20professional%20cleaning%20team%20with%20equipment%2C%20bright%20corporate%20interior%2C%20business%20atmosphere%2C%20spotless%20clean%20surfaces&width=400&height=400&seq=commercial-${index}&orientation=squarish')`
                  }}
                >
                  <i className={`${service.icon} text-3xl text-white drop-shadow-lg`}></i>
                </div>
                <h4 className="text-xl font-semibold text-gray-900 mb-3 text-center">
                  {service.title}
                </h4>
                <p className="text-gray-600 mb-4 text-center">
                  {service.description}
                </p>
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                <button 
                  onClick={scrollToContact}
                  className="w-full mt-6 bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Devis entreprise
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Services Nettoyage & Repassage */}
        <div id="laundry" className="mb-20">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              <i className="ri-shirt-line text-purple-600 mr-3"></i>
              Lessive & Repassage
            </h3>
            <p className="text-lg text-gray-600">
              Prise en charge complète de votre linge avec un service à domicile
            </p>
            <Link 
              to="/services/laundry"
              className="inline-flex items-center text-purple-600 hover:text-purple-800 font-medium mt-2 cursor-pointer"
            >
              En savoir plus
              <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {laundryServices.map((service, index) => (
              <div key={index} className="bg-gray-50/50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div 
                  className="w-20 h-20 bg-gradient-to-br from-purple-500 to-purple-600 rounded-2xl flex items-center justify-center mx-auto mb-6 bg-cover bg-center"
                  style={{
                    backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20laundry%20and%20ironing%20service%20$%7Bservice.title.toLowerCase%28%29%7D%20with%20clean%20folded%20clothes%2C%20modern%20laundry%20equipment%2C%20purple%20and%20white%20color%20scheme%2C%20high%20quality%20photography%2C%20steam%20iron%2C%20fresh%20clean%20garments%2C%20professional%20laundry%20setup%2C%20bright%20clean%20environment&width=400&height=400&seq=laundry-${index}&orientation=squarish')`
                  }}
                >
                  <i className={`${service.icon} text-3xl text-white drop-shadow-lg`}></i>
                </div>
                <h4 className="text-xl font-semibold text-gray-900 mb-3 text-center">
                  {service.title}
                </h4>
                <p className="text-gray-600 mb-4 text-center">
                  {service.description}
                </p>
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-purple-500 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                <button 
                  onClick={scrollToContact}
                  className="w-full mt-6 bg-purple-600 text-white py-2 rounded-lg hover:bg-purple-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Réserver service
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Services Courses & Livraison */}
        <div id="delivery" className="mb-12">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              <i className="ri-truck-line text-orange-600 mr-3"></i>
              Courses & Livraison
            </h3>
            <p className="text-lg text-gray-600">
              Services de courses personnelles et livraison pour particuliers et entreprises
            </p>
            <Link 
              to="/services/delivery"
              className="inline-flex items-center text-orange-600 hover:text-orange-800 font-medium mt-2 cursor-pointer"
            >
              En savoir plus
              <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {deliveryServices.map((service, index) => (
              <div key={index} className="bg-gray-50/50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div 
                  className="w-20 h-20 bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl flex items-center justify-center mx-auto mb-6 bg-cover bg-center"
                  style={{
                    backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20delivery%20and%20shopping%20service%20$%7Bservice.title.toLowerCase%28%29%7D%20with%20grocery%20bags%2C%20delivery%20truck%2C%20orange%20and%20white%20color%20scheme%2C%20high%20quality%20photography%2C%20fresh%20groceries%2C%20professional%20delivery%20person%2C%20modern%20logistics%2C%20efficient%20service%2C%20customer%20satisfaction&width=400&height=400&seq=delivery-${index}&orientation=squarish')`
                  }}
                >
                  <i className={`${service.icon} text-3xl text-white drop-shadow-lg`}></i>
                </div>
                <h4 className="text-xl font-semibold text-gray-900 mb-3 text-center">
                  {service.title}
                </h4>
                <p className="text-gray-600 mb-4 text-center">
                  {service.description}
                </p>
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-orange-500 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                <button 
                  onClick={scrollToContact}
                  className="w-full mt-6 bg-orange-600 text-white py-2 rounded-lg hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Commander service
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
